import { useApi } from '@backstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { syntaxHighlighterApiRef } from '../api';
import { SyntaxHighlighterQuery } from '@appfolio/backstage-plugin-syntax-highlighter-common';

export const useSyntaxHighlighter = (query: SyntaxHighlighterQuery) => {
  const api = useApi(syntaxHighlighterApiRef);
  const {
    data: output,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: [
      'syntax-highlighter',
      query.code,
      query.language,
      query.theme,
      Boolean(query.colorizeBrackets),
    ],
    queryFn: async () => api.highlight(query),
    refetchOnWindowFocus: false,
  });
  return {
    output,
    isLoading,
    isFetching,
    isError,
    error: error as Error,
  };
};
